module.exports = __webpack_public_path__ + "img/2.9c2c700c.png";